[
  {
    "path": "org/ml",
    "url": "https://www.fireweaver.org/org/ml"
  },
  {
    "path": "org/org",
    "url": "https://www.fireweaver.org/org/org"
  },
  {
    "path": "org/snippets",
    "url": "https://www.fireweaver.org/org/snippets"
  }
]
